import React, { useEffect, useMemo, useState } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField"
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from "framer-motion"
import { useHistory } from "react-router-dom"
import { FaPlus } from "react-icons/fa6"
import Dialog from "../../Components/Dialog"
import Button from "../../Components/Button"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import dummy from "../../Assets/Images/dummyProfile.jpeg"
import { FiImage } from "react-icons/fi"
import { HiOutlineArrowPathRoundedSquare, HiOutlineEye, HiOutlineKey, HiOutlinePencilSquare, HiOutlinePhoto, HiOutlineTrash } from "react-icons/hi2"
import { RiWhatsappLine } from "react-icons/ri"
import UserStatusDropdown from "../../Components/UserStatusDropdown"
import UserRowActionsMenu from "../../Components/UserRowActionsMenu"
import UserListSlideOvers from "./UserListSlideOvers"
import WhatsAppMatchShareDialog from "./WhatsAppMatchShareDialog"

createTheme("defaultLight", datatableTheme.default)
createTheme("defaultDark", datatableTheme.dark)

const status = [{ id: 0, value: "Pending" }, { id: 1, value: "Approved" }, { id: 2, value: "Declined" }, { id: 3, value: "In-active" }, { id: 4, value: "💍 Married" }, { id: 5, value: "Blocked" }, { id: 6, value: "Under Review" }]

const normalizePhoneDigits = (value) => (value || "").toString().replace(/\D/g, "")

const normalizeStatus = (s) => {
    if (s === 'Approved' || s === 'approved' || s === 'Active' || s === 'active') return 1
    if (s === 'Pending'  || s === 'pending')  return 0
    if (s === 'Declined' || s === 'declined') return 2
    return typeof s === 'number' ? s : parseInt(s, 10) || 0
}

const getVerificationStatusOptions = (currentStatus) => {
    const s = normalizeStatus(currentStatus)

    if (s === 6) {
        return [
            { value: 6, label: "Under Review" },
            { value: 1, label: "Approved" },
        ]
    }

    if ([0, 1, 2, 4].includes(s)) {
        return [
            { value: 0, label: "Pending" },
            { value: 1, label: "Approved" },
            { value: 2, label: "Declined" },
            { value: 4, label: "Happy Customer" },
        ]
    }

    return [{ value: s, label: status.find((item) => item.id === s)?.value || "Pending" }]
}

const PendingUsers = ({ match }) => {
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState("")
    const [userList, setUserList] = useState([])
    const history = useHistory()
    const [userId, setUserId] = useState()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openActiveModal, setOpenActiveModal] = useState(false)
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)
    const [currentPage] = useState(1)
    const [rowsPerPage] = useState(10)
    const [totalUsers, setTotalUsers] = useState()
    const [statusUpdatingId, setStatusUpdatingId] = useState(null)
    const [openCreateUser, setOpenCreateUser] = useState(false)
    const [selectedDetailUser, setSelectedDetailUser] = useState(null)
    const [selectedEditUser, setSelectedEditUser] = useState(null)
    const [selectedPasswordUser, setSelectedPasswordUser] = useState(null)
    const [selectedMatchTargetUser, setSelectedMatchTargetUser] = useState(null)
    const [createUserActions, setCreateUserActions] = useState(null)
    const [editUserActions, setEditUserActions] = useState(null)

    useEffect(() => {
        setLoading(true)
        API.get(`/user/getUserListByStatus/${match.params.status}`).then((userRes) => {
            if (userRes.status === 200) {
                const payload = userRes.data?.data
                const users = Array.isArray(payload) ? payload : (Array.isArray(payload?.users) ? payload.users : [])
                setUserList(users)
                setTotalUsers(payload?.totalUsers ?? users.length)
                setLoading(false)
            }
        }).catch(() => {
            setUserList([])
            setLoading(false)
        })
    }, [count, match.params.status])

    const openWhatsAppShare = (row) => {
        const rawNumber = row?.contactInformation?.whatsappNumber || row?.contactInformation?.mobileNumber || ""
        const cleanNumber = rawNumber.replace(/\D/g, "")

        if (!cleanNumber) {
            dispatch(setAlert({ title: "Error", subtitle: "Whatsapp number is not available for this user", active: true, type: "error" }))
            return
        }

        const formattedNumber = cleanNumber.length === 10 ? `91${cleanNumber}` : cleanNumber
        const message = encodeURIComponent(`Hello ${row?.firstName || ""}, this is Royal Kavery admin support. Ref ID: ${row?.refId || "-"}.`)
        window.open(`https://wa.me/${formattedNumber}?text=${message}`, "_blank", "noopener,noreferrer")
    }

    const columns = useMemo(() => [
        { name: "S.No", selector: (row, i) => (currentPage - 1) * rowsPerPage + i + 1, sortable: true, width: "100px" },
        {
            name: <FiImage />,
            selector: (row) => <motion.div className="flex h-full w-full items-center justify-center px-2 py-2"><img src={row?.images?.length > 0 ? row?.images[0]?.imageUrl : dummy} alt="user" className="h-16 w-16 rounded-2xl object-cover ring-1 ring-borderColor" /></motion.div>,
            initialActive: true, sortable: true,
        },
        { name: "Ref Id", selector: (row) => row.refId, initialActive: true, sortable: true, width: "100px" },
        {
            name: "First Name",
            selector: (row) => (
                <button
                    type="button"
                    className="text-left font-semibold text-tColor transition hover:text-primeColor"
                    onClick={() => setSelectedDetailUser(row)}
                >
                    {row.firstName}
                </button>
            ),
            sortable: true
        },
        { name: "Surname", selector: (row) => row.surname, sortable: true },
        {
            name: "Mobile / Login ID",
            selector: (row) => row?.contactInformation?.mobileNumber,
            sortable: true,
            minWidth: "190px",
            cell: (row) => (
                <div className="flex flex-col py-2 text-left">
                    <span className="font-semibold text-tColor">{row?.contactInformation?.mobileNumber || "-"}</span>
                    <span className="text-xs font-medium text-tpColor">Use this mobile number for member login</span>
                </div>
            ),
        },
        {
            name: "Verification Status",
            selector: (row) => (
                <UserStatusDropdown
                    value={row.status}
                    options={getVerificationStatusOptions(row.status)}
                    loading={statusUpdatingId === row._id}
                    onChange={(nextStatus) => updateVerificationStatus(row, nextStatus)}
                />
            ),
            sortable: true,
            minWidth: "220px",
        },
        { name: "Status", selector: (row) => <span className={`status-pill ${row.activeStat === "A" ? "status-pill--success" : "status-pill--danger"}`}>{row.activeStat === "A" ? "Active" : "Deactivated"}</span>, sortable: true },
        {
            name: "Action",
            selector: (row) => (
                <div className="flex w-full justify-center">
                    <UserRowActionsMenu
                        actions={[
                            { label: "View Details", icon: HiOutlineEye, onClick: () => setSelectedDetailUser(row) },
                            { label: "Edit User", icon: HiOutlinePencilSquare, onClick: () => setSelectedEditUser(row) },
                            { label: "Change Password", icon: HiOutlineKey, onClick: () => setSelectedPasswordUser(row) },
                            { label: "Manage Images", icon: HiOutlinePhoto, onClick: () => history.push(`/manageImages/${row._id}`) },
                            { label: "Share on WhatsApp", icon: RiWhatsappLine, onClick: () => openWhatsAppShare(row) },
                            { label: "Send Matching Profiles", icon: RiWhatsappLine, onClick: () => setSelectedMatchTargetUser(row) },
                            row.activeStat === "A"
                                ? { label: "Deactivate User", icon: HiOutlineTrash, danger: true, onClick: () => deactivateUser(row) }
                                : { label: "Activate User", icon: HiOutlineArrowPathRoundedSquare, onClick: () => activateUser(row) },
                        ]}
                    />
                </div>
            ),
            sortable: true,
        },
    ], [currentPage, history, rowsPerPage, statusUpdatingId]) // eslint-disable-line

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(" ").filter(Boolean)

        const flattenObjectToString = (obj) => {
            let result = ""
            const stack = [obj]

            while (stack.length) {
                const current = stack.pop()
                for (const key in current) {
                    const value = current[key]
                    if (value && typeof value === "object") {
                        stack.push(value)
                    } else if (value != null) {
                        result += ` ${value.toString().toLowerCase()}`
                    }
                }
            }

            return result
        }

        const digitFilter = normalizePhoneDigits(filter)
        const highPriority = []
        const mobileMatches = []
        const others = []

        userList.forEach((user) => {
            const firstName = user?.firstName?.toLowerCase() || ""
            const searchString = flattenObjectToString(user)
            const mobileSearch = normalizePhoneDigits(user?.contactInformation?.mobileNumber)

            const matchesAll = filterSplit.every((kw) => searchString.includes(kw))
            const matchesDigitSearch = digitFilter ? mobileSearch.includes(digitFilter) : false
            const firstNameMatchesAll = filterSplit.every((kw) => firstName.includes(kw))

            if (matchesAll || matchesDigitSearch) {
                if (firstNameMatchesAll) {
                    highPriority.push(user)
                } else if (matchesDigitSearch) {
                    mobileMatches.push(user)
                } else {
                    others.push(user)
                }
            }
        })

        return [...highPriority, ...mobileMatches, ...others]
    }, [userList, filter])

    const SubHeader = useMemo(() => (
        <div className="table-toolbar">
            <div className="toolbar-actions">
                <motion.button type="button" className="inline-flex min-h-[46px] items-center rounded-2xl bg-primeColor px-5 py-3 text-sm font-bold text-white shadow-soft transition hover:bg-primeDark" onClick={() => downloadAsExcel(match.params.status)}>Export Excel</motion.button>
                <span className="status-pill status-pill--warning">{totalUsers || filteredcasedetails.length} records</span>
            </div>
            <div className="toolbar-actions">
                <InlineTextField label={"Users"} placeholder={"Search by name, ref id, or mobile number"} value={filter} setValue={setFilter} />
                <motion.button type="button" className="flex h-[46px] w-[46px] items-center justify-center rounded-2xl bg-tColor text-white shadow-soft transition hover:bg-primeColor" onClick={() => setOpenCreateUser(true)}><FaPlus /></motion.button>
            </div>
        </div>
    ), [filter, totalUsers, filteredcasedetails.length, match.params.status]) // eslint-disable-line

    const deactivateUser = (values) => {
        setUserId(values._id)
        setOpenDeleteModal(true)
    }

    const activateUser = (values) => {
        setUserId(values._id)
        setOpenActiveModal(true)
    }

    const updateVerificationStatus = async (row, nextStatus) => {
        if (row?.status === nextStatus || statusUpdatingId === row?._id) return

        let endpoint = null
        let successSubtitle = "Status updated successfully"

        if (nextStatus === 0) {
            endpoint = `/user/moveToPending/${row._id}`
            successSubtitle = "Profile moved to pending successfully"
        } else if (nextStatus === 1) {
            endpoint = row.status === 6 ? `/user/verifyProfile/${row._id}` : `/user/approveUser/${row._id}`
            successSubtitle = row.status === 6 ? "Profile verified successfully" : "Profile approved successfully"
        } else if (nextStatus === 2) {
            endpoint = `/user/declineUser/${row._id}`
            successSubtitle = "Profile declined successfully"
        }

        if (!endpoint) return

        try {
            setStatusUpdatingId(row._id)
            const response = await API.get(endpoint)
            if (response.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: successSubtitle, active: true, type: "success" }))
                setCount((prev) => prev + 1)
            }
        } catch (error) {
            dispatch(setAlert({ title: "Error", subtitle: "Unable to update status right now", active: true, type: "error" }))
        } finally {
            setStatusUpdatingId(null)
        }
    }

    const deleteUser = () => {
        try {
            API.post(`/user/deactivateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: "Success", subtitle: "User Deactivated Successfully", active: true, type: "success" }))
                    setOpenDeleteModal(false)
                    setCount((prev) => prev + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: "Error", subtitle: "Something went wrong", active: true, type: "error" }))
        }
    }

    const reactiveUser = () => {
        try {
            API.post(`/user/activateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: "Success", subtitle: "User activated Successfully", active: true, type: "success" }))
                    setOpenActiveModal(false)
                    setCount((prev) => prev + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: "Error", subtitle: "Something went wrong", active: true, type: "error" }))
        }
    }

    const downloadAsExcel = async (statusValue) => {
        try {
            const response = await API.get(`/user/xlsxUsersDownload/${statusValue}`, {
                responseType: "blob",
            })
            const fileName = statusValue === "0" ? "Pending_User_List" : statusValue === "1" ? "Approved_User_List" : statusValue === "4" ? "Happy_Customer_List" : statusValue === "2" ? "Deactivated_User_List" : statusValue === "7" && "Paid_Members_List"
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers["content-type"] })
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = `${fileName}.xlsx`
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
            }
        } catch (err) {
            dispatch(setAlert({ title: "Error", subtitle: "Something went wrong while downloading", active: true, type: "error" }))
        }
    }

    return (
        <motion.div className="space-y-5">
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="datatable-shell panel-card h-full w-full overflow-hidden">
                    <DataTable
                        title="User List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={"There are no records to display"}
                    />
                </motion.div>
            )}
            <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={"Deactivate User"} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between mt-3">
                        <Button type="secondary" injectClass="rounded-full" onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button type="danger" injectClass="rounded-full" onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={"Activate User"} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between mt-3">
                        <Button type="secondary" injectClass="rounded-full" onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button type="primary" injectClass="rounded-full" onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <UserListSlideOvers
                openCreateUser={openCreateUser}
                createSubtitle="Create a member profile here and return to the same filtered queue automatically."
                onCloseCreate={() => setOpenCreateUser(false)}
                onCreated={() => {
                    setOpenCreateUser(false)
                    setCount((prev) => prev + 1)
                }}
                createUserActions={createUserActions}
                onCreateActionsReady={setCreateUserActions}
                selectedDetailUser={selectedDetailUser}
                onCloseDetail={() => setSelectedDetailUser(null)}
                selectedEditUser={selectedEditUser}
                onCloseEdit={() => setSelectedEditUser(null)}
                onEditSaved={() => {
                    setSelectedEditUser(null)
                    setCount((prev) => prev + 1)
                }}
                editUserActions={editUserActions}
                onEditActionsReady={setEditUserActions}
                selectedPasswordUser={selectedPasswordUser}
                onClosePassword={() => setSelectedPasswordUser(null)}
            />
            <WhatsAppMatchShareDialog
                open={Boolean(selectedMatchTargetUser)}
                onClose={() => setSelectedMatchTargetUser(null)}
                targetUser={selectedMatchTargetUser}
                profiles={userList}
            />
        </motion.div>
    )
}

export default PendingUsers
